module.exports = __webpack_public_path__ + "static/media/avatar-user.b1f46f42.png";